import React from 'react'
import {Segment, List} from 'semantic-ui-react'

const LongTermDeregistrations = ({deregistratons}) => {
    const deregistered = deregistratons
        .map(d =>
            <List.Item key={d.playerName}>
                <List.Icon name='user md' color='red' size='large'/>
                <List.Content>
                    {d.playerName} er langtidsavmeldt til {new Date(d.deregisteredToDate).toLocaleDateString()}
                </List.Content>
            </List.Item>
        );

    return (
        deregistered.length ?
        <Segment>
            <List>
                {deregistered}
            </List>
        </Segment> : null
    )
};

export default LongTermDeregistrations


// WEBPACK FOOTER //
// ./src/Components/LongTermDeregistrations.js